import { getValidHttpUrl } from "@/lib/url";

interface DiscordPreviewProps {
  metaTags: {
    og_title?: string;
    og_description?: string;
    og_image?: string;
    og_site_name?: string;
  };
}

// Discord embeds render on a dark surface regardless of the visitor's theme,
// so this preview intentionally keeps Discord's dark palette in light mode too.
export default function DiscordPreview({ metaTags }: DiscordPreviewProps) {
  const { og_title, og_description, og_image, og_site_name } = metaTags;
  const imageUrl = getValidHttpUrl(og_image);

  return (
    <div className="w-full max-w-lg rounded-lg bg-[#313338] p-4 shadow-md">
      <div className="max-w-md rounded-[4px] border-l-4 border-[#1e1f22] bg-[#2b2d31] p-3">
        {og_site_name && <p className="text-xs text-[#b5bac1]">{og_site_name}</p>}
        <p className="mt-1 text-sm font-semibold text-[#00a8fc]">{og_title || "No title found"}</p>
        {og_description && <p className="mt-1 line-clamp-3 text-sm text-[#dbdee1]">{og_description}</p>}
        {imageUrl ? (
          <img src={imageUrl} alt={og_title ?? ""} className="mt-3 aspect-[1.91/1] w-full rounded object-cover" />
        ) : (
          <div className="mt-3 flex h-40 w-full items-center justify-center rounded bg-[#1e1f22]">
            <p className="text-sm text-[#b5bac1]">No image available</p>
          </div>
        )}
      </div>
    </div>
  );
}
